/// <reference types="jquery" />
import { DragDropScopes } from "Agile/Scripts/Common/Agile";
import { NavigationUtils } from "Agile/Scripts/Common/NavigationUtils";
import { SprintsHubStorageConstants } from "Agile/Scripts/Generated/HubConstants";
import { IterationTimeframe } from "Agile/Scripts/Models/Iteration";
import { ScopedEventHelper } from "Agile/Scripts/ScopedEventHelper";
import { Events, EventType, TracePoints } from "Agile/Scripts/SprintsHub/Taskboard/AutoRefresh/TaskboardAutoRefreshConstants";
import { PublishAutoRefreshTelemetry } from "Agile/Scripts/SprintsHub/Taskboard/AutoRefresh/TaskboardAutoRefreshTelemetry";
import { TaskboardWorkItemChangedPayload } from "Agile/Scripts/SprintsHub/Taskboard/AutoRefresh/TaskboardWorkItemChangedPayload";
import { WorkItemTaskboardColumnChangedEvent } from "Agile/Scripts/SprintsHub/Taskboard/AutoRefresh/WorkItemTaskboardColumnChangedEvent";
import { TaskboardGroupBy } from "Agile/Scripts/Taskboard/TaskboardConstants";
import { ITaskboardModelOptions, TaskBoardModel } from "Agile/Scripts/Taskboard/TaskBoardModel";
import { TaskBoardView, TaskBoardViewState } from "Agile/Scripts/Taskboard/TaskBoardView";
import { BacklogConfigurationService } from "Presentation/Scripts/TFS/FeatureRef/BacklogConfiguration/Service";
import { DroppableWorkItemChangeOptions } from "Presentation/Scripts/TFS/FeatureRef/DroppableEnhancements";
import { FeatureAvailabilityFlags } from "Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants";
import { Level } from "VSS/ClientTrace/Contracts";
import * as VSSError from "VSS/Error";
import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";
import "VSS/LoaderPlugins/Css!Agile";
import "VSS/LoaderPlugins/Css!Agile/Taskboard/Taskboard";
import "VSS/LoaderPlugins/Css!Boards";
import { WorkItemChangeType } from "WorkItemTracking/Scripts/OM/WorkItemConstants";
import { WorkItemManager } from "WorkItemTracking/Scripts/OM/WorkItemManager";
import { RecycleBinConstants } from "WorkItemTracking/Scripts/RecycleBinConstants";
import { hasAgileToolsBacklogManagementPermission } from "WorkItemTracking/Scripts/Utils/PermissionHandler";
import { WitIdentityImages } from "WorkItemTracking/Scripts/Utils/WitIdentityImages";

import VSS = require("VSS/VSS");
import Diag = require("VSS/Diag");
import Events_Services = require("VSS/Events/Services");
import Utils_Core = require("VSS/Utils/Core");
import Utils_Array = require("VSS/Utils/Array");
import Utils_String = require("VSS/Utils/String");
import Controls = require("VSS/Controls");
import Events_Action = require("VSS/Events/Action");
import Identities_Picker_Controls = require("VSS/Identities/Picker/Controls");
import Identities_Picker_RestClient = require("VSS/Identities/Picker/RestClient");
import IdentityImage = require("Presentation/Scripts/TFS/TFS.IdentityImage");
import Navigation = require("VSS/Controls/Navigation");
import Q = require("q");

import WITConstants = require("Presentation/Scripts/TFS/Generated/TFS.WorkItemTracking.Constants");
import AgileResources = require("Agile/Scripts/Resources/TFS.Resources.Agile");

import WITDialogShim = require("WorkItemTracking/SharedScripts/WorkItemDialogShim");
import WITControls_RecycleBin = require("WorkItemTracking/Scripts/TFS.WorkItemTracking.Controls.RecycleBin");

import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import TFS_PendingOperationHelper = require("Presentation/Scripts/TFS/FeatureRef/PendingOperationHelper");
import TFS_Agile = require("Agile/Scripts/Common/Agile");
import TFS_Agile_Utils = require("Agile/Scripts/Common/Utils");
import Service = require("VSS/Service");
import TeamServices = require("TfsCommon/Scripts/Team/Services");
import TFS_OM_Common = require("Presentation/Scripts/TFS/TFS.OM.Common");
import TFS_OM_Identities = require("Presentation/Scripts/TFS/TFS.OM.Identities");
import WITOM = require("WorkItemTracking/Scripts/TFS.WorkItemTracking");
import Telemetry = require("VSS/Telemetry/Services");
import Menus = require("VSS/Controls/Menus");
import Cards = require("Agile/Scripts/Card/Cards");
import BoardsSettingsControls = require("Agile/Scripts/Board/BoardsSettingsControls");
import TFS_Agile_Controls = require("Agile/Scripts/Common/Controls");
import TFS_Agile_WorkItemChanges = require("Agile/Scripts/Common/WorkItemChanges");
import ConfigurationsConstants = require("Presentation/Scripts/TFS/TFS.Configurations.Constants");

import Agile_Utils_CSC_NO_REQUIRE = require("Agile/Scripts/Settings/CommonSettingsConfiguration");
import Configurations_NO_REQUIRE = require("Presentation/Scripts/TFS/TFS.Configurations");
import CardStyleCustomization_NO_REQUIRE = require("Agile/Scripts/Card/CardCustomizationStyle");
import TaskboardAutoRefreshHub_NO_REQUIRE = require("Agile/Scripts/SprintsHub/Taskboard/AutoRefresh/TaskboardAutoRefreshHub");

import CustomerIntelligenceConstants = require("Agile/Scripts/Common/CustomerIntelligence");
import AgileControlsResources = require("Agile/Scripts/Resources/TFS.Resources.AgileControls");
import Notifications = require("VSS/Controls/Notifications");

var WorkItemUtils = TFS_Agile_Utils.WorkItemUtils;
var ContextUtils = TFS_OM_Common.ContextUtils;
var DatabaseCoreFieldRefName = TFS_Agile_Utils.DatabaseCoreFieldRefName;
const globalEvents = Events_Services.getService();

/* tslint:disable:member-ordering */
export class TaskBoard implements IDisposable {
    private _container: JQuery;
    private _contributedPivotFilters: Menus.MenuBar;
    private _model: TaskBoardModel;
    private _view: TaskBoardView;
    private _workItemDraggingHandler: IEventHandler;
    private _workItemChangeRequestedHandler: IEventHandler;
    private _workItemReorderRequestedHandler: IEventHandler;
    private _editWorkItemHandler: IEventHandler;
    private _discardWorkItemHandler: IEventHandler;
    private _moveWorkItemToIterationHandler: IEventHandler;
    private _createNewWorkItemHandler: IEventHandler;
    private _newParentItemDiscardedHandler: () => void;
    private _pivotFilter: Navigation.PivotFilter;
    private _groupFilter: Navigation.PivotFilter;
    private _boardCardSettings: Cards.IBoardCardSettings;
    private static _boardType = "TASKBOARD";
    private _taskboardMenuBar: Menus.MenuBar;
    private _commonSettingsRegistered: boolean;
    private _workItemIdsToRemove: IDictionaryNumberTo<number>;
    private _workItemChangeEventHandler: IEventHandler;
    private _backlogLevelHelper: TFS_Agile_WorkItemChanges.BacklogLevelHelper;
    private _iterationPath: string;
    private _allowParentItemsToBeDraggable: boolean;
    private _useNewTaskboardDisplay: boolean;
    private _membershipTracker: TFS_Agile.MembershipTracker;
    private _permissions: TeamServices.ITeamPermissions;
    private _selectedIterationTimeframe?: IterationTimeframe;
    private _disposed: boolean;
    private _taskboardAutoRefreshEventsHelper: ScopedEventHelper;
    private _boardHub: TaskboardAutoRefreshHub_NO_REQUIRE.TaskboardAutoRefreshHub;
    private _signalRHubUrl?: string;

    public static CSS_TASKBOARD_MENUBAR = ".taskboard-menubar";
    protected _reorderManager: TFS_Agile.IReorderManager;

    // Set browser tab inactive time threshold to one hour.
    private _browserTabInactiveTimeInMillseconds: number = 60 * 60 * 1000;
    private _signalRDisconnectTimer: number = -1;

    /**
     * Constructs a TaskBoard object. This object plays the role of a Controller
     * that wires together a data source and a view, and handles events initiated by the user.
     *
     * @param container The element into which the taskboard view will be placed
     * @param data The initializer object for the TaskBoardData object
     * @param iterationPath The iteration path for this taskboard. For adding and validating items on the board.
     * @param boardCardSettings The board card settings
     * @param allowParentItemsToBeDraggable Should parents (ie User Stories) be draggable? Default to true to drag stories to different iterations.
     * @param onNewParentItemDiscarded Callback for when a new parent item is discarded.
     * @param useNewTaskboardDisplay Whether the taskboard use the display pattern expected in the new SprintsHub page
     */
    constructor(
        container: JQuery,
        data: ITaskboardModelOptions,
        iterationPath: string,
        boardCardSettings?: Cards.IBoardCardSettings,
        allowParentItemsToBeDraggable: boolean = true,
        onNewParentItemDiscarded?: () => void,
        useNewTaskboardDisplay: boolean = false,
        selectedIterationTimeframe?: IterationTimeframe,
        signalRHubUrl?: string
    ) {
        Diag.Debug.assertParamIsObject(container, "container");
        Diag.Debug.assertParamIsObject(data, "data");

        this._membershipTracker = new TFS_Agile.MembershipTracker(/* Taskboard does not subscribe to membership events, pass null */ null);

        this._container = container;
        this._model = new TaskBoardModel(data, useNewTaskboardDisplay);
        this._boardCardSettings = boardCardSettings;
        this._workItemIdsToRemove = {};
        this._iterationPath = iterationPath;

        this._setupHandlers();
        this._newParentItemDiscardedHandler = onNewParentItemDiscarded;

        this._primeWorkItemMetadata();

        // get pivot filter
        this._pivotFilter = <Navigation.PivotFilter>Controls.Enhancement.ensureEnhancement(Navigation.PivotFilter, $(".person-filter"));
        this._groupFilter = <Navigation.PivotFilter>Controls.Enhancement.ensureEnhancement(Navigation.PivotFilter, $(".group-filter"));
        this._reorderManager = new TFS_Agile.ReorderManager(data.team.id);

        if (this._pivotFilter) {
            // update people filter
            this._updatePeopleFilter();
        }

        if (boardCardSettings) {
            this._createSettingsMenubar(boardCardSettings);
        }

        this._allowParentItemsToBeDraggable = allowParentItemsToBeDraggable;
        this._useNewTaskboardDisplay = useNewTaskboardDisplay;
        this._selectedIterationTimeframe = selectedIterationTimeframe;
        this._signalRHubUrl = signalRHubUrl;

        // Do not use the global filter in the new display
        if (this._useNewTaskboardDisplay) {
            this._model.setFilter(null);
        }

        // Attach recycle events
        globalEvents.attachEvent(RecycleBinConstants.EVENT_DELETE_STARTED, this._handleDeleteStarted);
        globalEvents.attachEvent(RecycleBinConstants.EVENT_DELETE_FAILED, this._handleDeleteFailed);

        this._createContributedPivotFilters(["ms.vss-work-web.sprint-board-pivot-filter-menu"]);
        TFS_Agile_Utils.enableDragCancelling();

        const backlogsContext = TFS_Agile.BacklogContext.getInstance();
        if (backlogsContext.updateUrlActionAndParameter) {
            const agileContext: TFS_Agile.AgileContext = new TFS_Agile.AgileContext();
            const iterationName = agileContext.getContext().iteration.name;
            NavigationUtils.rewriteBacklogsUrl(NavigationUtils.taskboardPageAction, iterationName);
        } else if (!useNewTaskboardDisplay) {
            NavigationUtils.rememberMruHub();
        }

        Telemetry.publishEvent(
            new Telemetry.TelemetryEventData(
                CustomerIntelligenceConstants.AgileCustomerIntelligenceArea.AGILE,
                CustomerIntelligenceConstants.AgileCustomerIntelligenceFeature.TELEMETRY_TASKBOARD_ITEMCOUNT,
                {
                    ParentItemCount: this._model.getParentItemCount(),
                    ChildItemCount: this._model.getChildItemCount()
                }
            )
        );

        this._taskboardAutoRefreshEventsHelper = new ScopedEventHelper("Taskboard_" + new Date().getTime().toString());

        if (!FeatureAvailabilityService.isFeatureEnabled(FeatureAvailabilityFlags.WebAccessAgileTaskboardDisableLiveUpdates, false)) {
            const tfsContext = TFS_Host_TfsContext.TfsContext.getDefault();
            const thirdPartyUrl = tfsContext.configuration.get3rdPartyStaticRootPath();
            const minified = !Diag.getDebugMode() ? "min." : "";
            const signalRScript = Utils_String.format("{0}_scripts/jquery.signalR-upd.2.2.0.{1}js", thirdPartyUrl, minified);

            VSS.requireModules([signalRScript]).then(
                () => {
                    // Subscribe for refresh notifications.
                    this._setupAutoRefresh().done(
                        (boardFromPromise: TaskboardAutoRefreshHub_NO_REQUIRE.TaskboardAutoRefreshHub) => {},
                        (error: Error) => {
                            if (error.name === "Taskboard.AutoRefresh.Hub.Connection.Start.Timeout") {
                                VSSError.publishErrorToTelemetry(error, false, Level.Error, {
                                    signalRError: true,
                                    vssRequireFailed: false,
                                    timeout: true
                                });
                                this._tearDownAutoRefresh(
                                    /*promptForManualRefresh*/ true,
                                    Events.SignalRConnectionStartTimedOut,
                                    AgileControlsResources.RefreshNotification_ConnectionTimedout
                                );
                            } else if (error.name === "Taskboard.AutoRefresh.ScriptLoad.Failure") {
                                VSSError.publishErrorToTelemetry(error, false, Level.Error, {
                                    signalRError: true,
                                    vssRequireFailed: false,
                                    timeout: true
                                });
                                this._tearDownAutoRefresh(
                                    /*promptForManualRefresh*/ true,
                                    Events.SignalRScriptLoadingFailed,
                                    AgileControlsResources.RefreshNotification_ConnectionTimedout
                                );
                            } else {
                                VSSError.publishErrorToTelemetry(error, false, Level.Error, {
                                    signalRError: true,
                                    vssRequireFailed: false,
                                    timeout: false
                                });
                            }
                        }
                    );
                },
                (error: Error) => {
                    VSSError.publishErrorToTelemetry(error, false, Level.Error, { signalRError: true, vssRequireFailed: true, timeout: false });
                    this._tearDownAutoRefresh(
                        /*promptForManualRefresh*/ true,
                        Events.SignalRConnectionStartTimedOut,
                        AgileControlsResources.RefreshNotification_SignalRFailedToLoad
                    );
                }
            );
        }
    }

    public getTaskBoardView(): TaskBoardView {
        return this._view;
    }

    public getTaskBoardModel(): TaskBoardModel {
        return this._model;
    }

    /**
     * Shows the taskboard
     * @param classificationType The type of classification.  Valid values for classification are exposed as TaskBoardView.*_CLASSIFICATION
     */
    public show(classificationType: string): void {
        Diag.Debug.assert(this._model !== null, "Model should not be null");

        Diag.logTracePoint("TaskBoard.show.start");

        // Default the the classification type if it is not set.
        classificationType = classificationType || TaskboardGroupBy.PARENT_CLASSIFICATION;

        // If the view has not been created, create the view and attach to its events.
        if (!this._view) {
            this._view = new TaskBoardView(
                this._container,
                this._model.teamId,
                this._allowParentItemsToBeDraggable,
                this._useNewTaskboardDisplay,
                this._selectedIterationTimeframe
            );
            this._attachViewEvents();

            if (this._boardCardSettings) {
                const cardSettingsProvider: Cards.CardSettingsProvider = new Cards.CardSettingsProvider(this._boardCardSettings);
                this._view.setCardSettingsProvider(cardSettingsProvider);
            }
        }

        this._view.display(this._model, classificationType);
    }

    /**
     * Apply a new filter to the taskboard
     *
     * @param filter The filter to apply, as a dictionary of field reference names to values.
     */
    public filterWorkItems(filter: WITOM.IFieldValueDictionary) {
        Diag.logTracePoint("Taskboard.filterWorkItems.start");
        Diag.Debug.assertParamIsObject(filter, "filter");

        var startTime = Date.now();

        var fieldRefName: string;

        this._model.setFilter(filter);
        this._view.applyFilter();
        for (fieldRefName in filter) {
            if (filter.hasOwnProperty(fieldRefName)) {
                ContextUtils.saveTeamUserStringSetting(
                    this._model.teamId,
                    SprintsHubStorageConstants.AgileBoardFilter + fieldRefName,
                    filter[fieldRefName]
                );
            }
        }

        Diag.logTracePoint("Taskboard.filterWorkItems.complete");
        Telemetry.publishEvent(
            new Telemetry.TelemetryEventData(
                CustomerIntelligenceConstants.AgileCustomerIntelligenceArea.AGILE,
                CustomerIntelligenceConstants.AgileCustomerIntelligenceFeature.CLIENTSIDEOPERATION_ITERATION_TASKBOARD_FILTER,
                {},
                startTime
            )
        );
    }

    /**
     * Return work item manager.
     */
    public getWorkItemManager(): WorkItemManager {
        return this._model.getWorkItemManager();
    }

    /**
     * Add a new parent work item to the taskboard
     * @param workItemType The work item type that the parent should be
     */
    public addNewParentItem(workItemType: string) {
        this._createNewWorkItem(workItemType, this._iterationPath, /*parentId*/ null, /*isNewParent*/ true);
    }

    public dispose() {
        this._disposed = true;
        this.detachEvents();

        if (this._membershipTracker) {
            this._membershipTracker.dispose();
            this._membershipTracker = null;
        }

        this._view.dispose();
        this._view = null;

        this._model.dispose();
        this._model = null;

        if (this._reorderManager) {
            this._reorderManager.dispose();
            this._reorderManager = null;
        }

        this._tearDownAutoRefresh(/*promptForManualRefresh*/ false);
        this._detachVisibilityChangedHandler();
    }

    public detachEvents() {
        this._detachViewEvents();
        // Detach recycle bin events
        globalEvents.detachEvent(RecycleBinConstants.EVENT_DELETE_STARTED, this._handleDeleteStarted);
        globalEvents.detachEvent(RecycleBinConstants.EVENT_DELETE_FAILED, this._handleDeleteFailed);
    }

    /**
     * Helper to check if a workitem exists on the taskboard
     * @param id
     */
    public isWorkItemOnTheBoard(id: number): boolean {
        return this._model && this._model.isWorkItemOnTheBoard(id);
    }

    /**
     * Get droppableWorkItemChangeOptions for the details panel
     */
    public getWorkItemChangeOptionsForDetailsPanel(): DroppableWorkItemChangeOptions {
        const store = TFS_OM_Common.ProjectCollection.getDefaultConnection().getService<WITOM.WorkItemStore>(WITOM.WorkItemStore);
        const options: DroppableWorkItemChangeOptions = {
            scope: DragDropScopes.WorkItem,
            workItemUpdate: (data) => {
                //Save the updates that the DroppableWorkItemChangeEnhancement has made to the workItem
                if (data.success) {
                    store.beginSaveWorkItemsBatch(
                        data.workItems,
                        () => {
                            if (this._view) {
                                for (let item of data.workItems) {
                                    this._view.refreshTile(item.id);
                                }
                            }
                        },
                        () => {
                            // Reset all failed work items
                            for (const workItem of data.workItems) {
                                workItem.reset();
                            }
                        }
                    );
                }
            },
            getDraggedWorkItemIds: (draggable: JQuery) => [this._view.getIdNumberFromElement(draggable)],
            isValidDropTarget: (workItemIds: number[], fieldName: string) => workItemIds.every((id) => this.isWorkItemOnTheBoard(id)),
            beginGetWorkItems: (workItemIds: number[], callback) => {
                WorkItemManager.get(store).beginGetWorkItems(workItemIds, callback);
            }
        };
        // TODO: Implement error handling #1145475

        return options;
    }

    public get isDisposed(): boolean {
        return this._disposed;
    }

    private _createContributedPivotFilters(contributionIds: string[]) {
        if (!this._contributedPivotFilters) {
            var menuElem = $("<div />").addClass("agile-board-pivot-contributions").appendTo($(".filters"));
            this._contributedPivotFilters = Controls.create(Menus.MenuBar, menuElem, <Menus.MenuBarOptions>{
                contributionIds: contributionIds,
                getContributionContext: <Function>(() => {
                    var agileContextService = Service.getService(TFS_Agile.AgileContext);
                    var agileContext = agileContextService && agileContextService.getContext();
                    return {
                        iteration: agileContext && agileContext.iteration,
                        team: this._model.team
                    };
                }),
                cssClass: TaskBoard.CSS_TASKBOARD_MENUBAR.substr(1),
                emptyMenuInTabOrder: false
            });
        } else {
            this._contributedPivotFilters.refreshContributedItems();
        }
    }

    private _createSettingsMenubar(boardCardSettings: Cards.IBoardCardSettings) {
        /// <summary> Creates board settings menubar</summary>
        /// <param name="boardCardSettings" type="IDictionaryStringTo<TFS_Agile.ICardFieldSetting[]>">Card settings for the board</param>

        const $menubar = $(TaskBoard.CSS_TASKBOARD_MENUBAR);

        if (!this._taskboardMenuBar && $menubar.length > 0) {
            $menubar.toggleClass("agile-important-hidden", false);
            this._taskboardMenuBar = <Menus.MenuBar>Controls.Enhancement.enhance(Menus.MenuBar, $menubar);

            // Initialize fullscreen menuitem
            Navigation.FullScreenHelper.initialize(this._taskboardMenuBar);
        }

        // Initialize commonSettingsConfiguration menuitem and register tabs
        this._attachCommonConfigurationRegistration();

        // Taskboard menu bar can be null in the sprints hub
        if (this._taskboardMenuBar) {
            TFS_Agile_Controls.CommonSettingsConfigurationControl.initialize(this._taskboardMenuBar, () => {
                this._recordTaskboardCommonConfigDialogTelemetry();
            });
        }
    }

    private _attachCommonConfigurationRegistration() {
        const tfsContext = TFS_Host_TfsContext.TfsContext.getDefault();
        Service.getService(TeamServices.TeamPermissionService)
            .beginGetTeamPermissions(tfsContext.navigation.projectId, this._model.teamId)
            .then((permissions: TeamServices.ITeamPermissions) => {
                this._permissions = permissions;
                Events_Action.getService().registerActionWorker(
                    ConfigurationsConstants.Actions.LAUNCH_COMMON_CONFIGURATION,
                    this._launchCommonConfiguration
                );
            });
    }

    private _launchCommonConfiguration = (actionArgs, next: (args) => void) => {
        VSS.using(
            ["Presentation/Scripts/TFS/TFS.Configurations", "Agile/Scripts/Settings/CommonSettingsConfiguration"],
            (Configuration: typeof Configurations_NO_REQUIRE, Agile_Utils_CSC: typeof Agile_Utils_CSC_NO_REQUIRE) => {
                if (!this.isDisposed) {
                    const perfScenario = TFS_Agile_Controls.CommonSettingsConfigurationControl.createPerfScenario(
                        TFS_Agile.AgileCustomerIntelligenceConstants.ITERATION_BOARD_VIEW,
                        !this._commonSettingsRegistered
                    );

                    if (!this._commonSettingsRegistered) {
                        Configuration.TabControlsRegistration.clearRegistrations(
                            TFS_Agile.TabControlsRegistrationConstants.COMMON_CONFIG_SETTING_INSTANCE_ID
                        );
                        const isEditable = this._permissions.currentUserHasTeamAdminPermission && hasAgileToolsBacklogManagementPermission();

                        // card field tab
                        const cardFieldControlOptions: BoardsSettingsControls.IFieldSettingsControlOptions = {
                            teamId: this._model.teamId,
                            boardCardSettings: this._boardCardSettings.cards,
                            additionalCoreFields: this._getAdditionalCoreFieldsForCardCustomization(this._boardCardSettings.cards),
                            isEditable: isEditable,
                            boardType: TaskBoard._boardType,
                            defaultWorkItemTypeName: this._getDefaultWorkITemType(),
                            refreshOnSave: true
                        };

                        // card style tab
                        const cardStyleOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions = {
                            teamId: this._model.teamId,
                            styleRules: this._boardCardSettings.styles,
                            isEditable: isEditable,
                            disableSave: null,
                            itemTypes: this._getWitTypes(),
                            requireRefreshOnSave: true,
                            boardIdentity: this._model.teamId,
                            boardType: TFS_Agile_Utils.BoardType.Taskboard
                        };

                        actionArgs = actionArgs || {};

                        Agile_Utils_CSC.registerTaskboardSettingsForIterationLevel(
                            this._model.teamId,
                            this._permissions,
                            !actionArgs.hideBacklogVisibilitiesTab,
                            cardFieldControlOptions,
                            cardStyleOptions
                        );

                        this._commonSettingsRegistered = true;
                    }

                    actionArgs = $.extend(
                        {
                            perfScenario: perfScenario,
                            okText: AgileResources.SaveAndCloseButtonName
                        },
                        actionArgs
                    );
                    next(actionArgs);
                }
            }
        );
    };

    private _getWitTypes(): string[] {
        const witTypes: string[] = [];
        if (this._boardCardSettings && this._boardCardSettings.cards) {
            for (const witType of Object.keys(this._boardCardSettings.cards)) {
                if (this._boardCardSettings.cards[witType]) {
                    witTypes.push(witType);
                }
            }
        }
        return witTypes;
    }

    private _getDefaultWorkITemType(): string {
        let defaultWorkItemTypeName = this._getDefaultWorkItemTypeNameForTaskBacklog();
        if (!defaultWorkItemTypeName) {
            defaultWorkItemTypeName = TFS_Agile.BacklogContext.getInstance().level.defaultWorkItemType;
        }
        return defaultWorkItemTypeName;
    }

    private _recordTaskboardCommonConfigDialogTelemetry() {
        Telemetry.publishEvent(
            new Telemetry.TelemetryEventData(
                CustomerIntelligenceConstants.AgileCustomerIntelligenceArea.AGILE,
                CustomerIntelligenceConstants.AgileCustomerIntelligenceFeature.CLIENTSIDEOPERATION_COMMON_CONFIG_DIALOG_OPENED,
                {
                    Page: TFS_Agile.AgileCustomerIntelligenceConstants.ITERATION_BOARD_VIEW
                }
            )
        );
    }

    private _getDefaultWorkItemTypeNameForTaskBacklog(): string {
        return BacklogConfigurationService.getBacklogConfiguration().taskBacklog.defaultWorkItemType;
    }

    private _getAdditionalCoreFieldsForCardCustomization(
        boardCardSettings: IDictionaryStringTo<Cards.ICardFieldSetting[]>
    ): IDictionaryStringTo<string[]> {
        var additionalCoreFields: IDictionaryStringTo<string[]> = {};

        var childWitTypes = this._model.getChildWorkItemTypes();
        $.each(childWitTypes, (index: number, itemType: string) => {
            additionalCoreFields[itemType] = [];
            additionalCoreFields[itemType].push(this._model.getWorkRollupFieldRefName());
        });

        return additionalCoreFields;
    }

    private _setupHandlers(): void {
        // <summary>Setup event handlers for events on the taskboard</summary>
        this._workItemDraggingHandler = (source, id) => {
            this._primeWorkItemManager(id);
        };

        this._workItemChangeRequestedHandler = (source, args) => {
            Diag.Debug.assertParamIsObject(args, "args");
            Diag.Debug.assertParamIsNumber(args.id, "args.id");
            Diag.Debug.assertParamIsObject(args.workItemChanges, "args.workItemChanges");
            Diag.Debug.assertParamIsFunction(args.changeCompletedHandler, "args.changeCompletedHandler");

            this._changeWorkItem(args.id, args.workItemChanges, args.changeCompletedHandler);
        };

        this._workItemReorderRequestedHandler = (source, reorderOperation: TFS_Agile.IReorderOperation) => {
            Diag.Debug.assertIsObject(reorderOperation, "Unexpected reorderOperation");
            this._reorderManager.queueReorder(reorderOperation);
        };

        this._editWorkItemHandler = (source, id: number) => {
            this._editWorkItem(id);
        };

        this._discardWorkItemHandler = (source, id: number) => {
            this._discardNewWorkItem(id);
        };

        this._moveWorkItemToIterationHandler = (source, args: { id: number; iterationPath: string }) => {
            this.moveWorkItemToIteration(args.id, args.iterationPath);
        };

        this._createNewWorkItemHandler = (source, args) => {
            this._createNewWorkItem(args.workItemType, this._iterationPath, args.parentId);
        };
    }

    /**
     * Update people filter from model
     */
    private _updatePeopleFilter() {
        if (!this._pivotFilter) {
            return; // We don't have a pivot filter.
        }

        var pivotFilterItems: Navigation.IPivotFilterItem[] = [],
            peopleFilterValues: string[] = this._model.getFilterValues(),
            filter: WITOM.IFieldValueDictionary = this._model.getFilter() || {},
            selectedValue = filter[DatabaseCoreFieldRefName.AssignedTo];

        // determine the correct filter to mark as selected = filter["System.AssignedTo"];
        // Default to "All" if there's not filter set
        if (selectedValue === undefined) {
            selectedValue = TaskBoardModel.ALL_VALUE;
        }

        // Build the pivot filter items.
        var showItemIcons = false; // Should the pivot filter menu show (and reserve space for) menu items' icons?
        $.each(peopleFilterValues, (i, peopleFilterValue: string) => {
            var value: string;
            var displayText = peopleFilterValue;
            var identity: TFS_OM_Identities.IIdentityReference;

            switch (i) {
                case 0: // All
                    value = TaskBoardModel.ALL_VALUE;
                    break;
                case 1: // Unassigned
                    value = TaskBoardModel.UNASSIGNED_VALUE;
                    break;
                default:
                    identity = TFS_OM_Identities.IdentityHelper.parseUniquefiedIdentityName(peopleFilterValue);
                    if (identity) {
                        displayText = identity.displayName;
                    }
                    value = peopleFilterValue;
                    break;
            }

            var pivotFilterItem: Navigation.IPivotFilterItem = {
                value: value,
                selected: value === selectedValue,
                title: peopleFilterValue,
                text: displayText // All items must have text (for rendering when selected), even if they also have custom HTML for rendering when in the menu.
            };

            if (TFS_Agile_Utils.isUseNewIdentityControlsEnabled()) {
                // Render a custom item with the new identity display control.

                // (Determine what to display.)
                var item: string | Identities_Picker_RestClient.IEntity; // The identity to display. If unique-name string, the control will resolve the details from the server.
                var userFriendlyDisplayName: string; // The text to be displayed if/while the identity's details are being resolved from the server - not needed/used if item is already an IEntity.
                if (value === TaskBoardModel.ALL_VALUE) {
                    item = Identities_Picker_Controls.EntityFactory.createStringEntity(displayText, WitIdentityImages.AllUsersImageUrl);
                    userFriendlyDisplayName = displayText;
                } else if (value === TaskBoardModel.UNASSIGNED_VALUE) {
                    item = Identities_Picker_Controls.EntityFactory.createStringEntity(displayText, WitIdentityImages.UnassignedImageUrl);
                    userFriendlyDisplayName = displayText;
                } else {
                    item = (identity && identity.uniqueName) || displayText;
                    userFriendlyDisplayName = (identity && identity.displayName) || displayText;
                }

                // (Create & insert the actual control.)
                let $container = $("<span/>");
                let options: Identities_Picker_Controls.IIdentityDisplayOptions = {
                    identityType: { User: true, Group: true },
                    operationScope: { Source: true, IMS: true },
                    item: item,
                    friendlyDisplayName: userFriendlyDisplayName, // Display this name until the identity is asynchronously resolved.
                    size: Identities_Picker_Controls.IdentityPickerControlSize.Small, // 16px
                    turnOffHover: true,
                    consumerId: TFS_Agile.IdentityControlConsumerIds.TaskBoardFilterDisplayControl
                };
                Controls.BaseControl.create(Identities_Picker_Controls.IdentityDisplayControl, $container, options);
                $.extend(pivotFilterItem, {
                    // Our filter is a dropdown-behavior pivot filter (see Navigation.DropdownFilterBehavior). This simply passes
                    // the IPivotFilterItems on to a PopupMenu as MenuItems.
                    html: $container,
                    showText: false
                });
            } else if (identity) {
                // Render a classic pivot item with the identity image as the icon.
                var getIdentityImage = () => {
                    return IdentityImage.identityImageElementByIdentifier(identity, null, peopleFilterValue, displayText);
                };
                $.extend(pivotFilterItem, {
                    text: displayText,
                    icon: identity && (identity.id || identity.uniqueName) ? getIdentityImage : null,
                    cssClass: identity ? "identity" : ""
                });
                showItemIcons = true;
            } else {
                // Just render a plain text pivot item.
                $.extend(pivotFilterItem, {
                    text: displayText
                });
            }

            pivotFilterItems.push(pivotFilterItem);
        });
        this._pivotFilter.updateItems(pivotFilterItems, { showItemIcons: showItemIcons });
    }

    /**
     * Update group filter from model
     */
    public updateGroupFilter(group: string, updateUI: boolean) {
        var values = [],
            filter = this._model.getGroupFilter() || {},
            groups = filter.values,
            selected = group;

        // if we don't have a filter element, don't do anything
        if (!this._groupFilter) {
            return;
        }

        // determine the correct filter to mark as selected
        // Default to "stories" if there's no filter set
        if (selected === null) {
            selected = TaskboardGroupBy.PARENT_CLASSIFICATION;
        }

        Utils_Core.delay(this, 500, () => {
            // persist the current group filter selection.   Do it in a delay because IE9 will only send
            // the header portion of the request (it's a post operation) while it's busy rendering/initializing which means
            // that these calls (setString) will appear to take a long time on the server.  Once rendering is completed
            // IE9 will send the body of the request.
            ContextUtils.saveTeamUserStringSetting(
                this._model.teamId,
                SprintsHubStorageConstants.AgileBoardFilter + SprintsHubStorageConstants.Group,
                selected
            );
        });

        // if we don't want to refresh the drop-down UI, return
        if (!updateUI) {
            return;
        }

        $.each(groups, (i, text) => {
            var value;

            switch (i) {
                case 0: // Team
                    value = TaskboardGroupBy.PEOPLE_CLASSIFICATION;
                    break;
                case 1: // Stories
                    value = TaskboardGroupBy.PARENT_CLASSIFICATION;
                    break;
                default:
                    value = text;
                    break;
            }

            values.push({
                text: text,
                value: value,
                selected: value === selected,
                title: text
            });
        });
        this._groupFilter.updateItems(values);
    }

    /**
     * Handle the start of a work item being edited
     *
     * @param id The work item ID
     */
    private _primeWorkItemManager(id: number) {
        Diag.Debug.assert(typeof id === "number", "Expected that id would be number");

        this._model.getWorkItemManager().beginGetWorkItem(id, $.noop);
    }

    /**
     * prefetch work item type data for the taskboard
     */
    private _primeWorkItemMetadata() {
        // Pre-fetch work item types.
        var store = TFS_OM_Common.ProjectCollection.getDefaultConnection().getService<WITOM.WorkItemStore>(WITOM.WorkItemStore);
        store.beginGetProject(TFS_Host_TfsContext.TfsContext.getDefault().navigation.projectId, (project: WITOM.Project) => {
            if (!this.isDisposed) {
                Diag.Debug.assertParamIsObject(project, "project");
                project.beginGetWorkItemTypes(this._model.getChildWorkItemTypes(), () => {});

                // Pre-fetch notes data without impacting TTI
                project.nodesCacheManager.beginGetNodes();
            }
        });
        this._model.getWorkItemStore().beginGetLinkTypes($.noop);
    }

    /**
     * Handle an update to a work item
     *
     * @param id The work item ID
     * @param workItemChanges Object which contains fieldData (maps field refnames to their new value) and other changes
     * @param changeCompletedHandler Function to invoke when the change has been completed.
     */
    private _changeWorkItem(id: number, workItemChanges: any, changeCompletedHandler: Function) {
        Diag.Debug.assertParamIsNumber(id, "id");
        Diag.Debug.assertParamIsObject(workItemChanges, "workItemChanges");
        Diag.Debug.assertParamIsFunction(changeCompletedHandler, "changeCompletedHandler");

        var witManager = this._model.getWorkItemManager(),
            pendingOperationId = "task-board-change-workitem",
            fieldChanges = workItemChanges.fieldChanges,
            newParentId = workItemChanges.newParentId;

        TFS_PendingOperationHelper.PendingOperationHelper.addOperation(pendingOperationId);

        var changeHandler = (args: WITOM.IWorkItemsBulkSaveSuccessResult, error?: number) => {
            // Notify that the change has been completed.
            if (!error) {
                //success

                changeCompletedHandler(id, args);

                // update the people filter in case of change to task items
                if (!this._model.isParentId(id)) {
                    this._updatePeopleFilter();
                }
            } else {
                changeCompletedHandler(id, args, error);
            }

            TFS_PendingOperationHelper.PendingOperationHelper.removeOperation(pendingOperationId);
        };

        witManager.beginGetWorkItem(
            id,
            (workItem) => {
                var refname, field;

                // New Parent ID has been set, so we need to relink
                // Also, New Parent ID can be zero, denoting an unparenting operation.
                // So we need to allow zero to go through.
                if (newParentId !== undefined && newParentId !== null) {
                    WorkItemUtils.reparentWorkItem(workItem, newParentId);
                }

                // apply requested field changes
                for (refname in fieldChanges) {
                    if (fieldChanges.hasOwnProperty(refname)) {
                        // For JSLint
                        field = workItem.getField(refname);
                        if (field) {
                            field.setValue(fieldChanges[refname]);
                        }
                    }
                }

                if (workItem.isValid()) {
                    witManager.store.beginSaveWorkItemsBatch(
                        [workItem],
                        (args: WITOM.IWorkItemsBulkSaveSuccessResult) => {
                            Diag.Debug.assert(
                                args && jQuery.isArray(args.workItems),
                                "Expected a list of updated work items to be passed when the work items are saved"
                            );
                            Diag.Debug.assert(args.workItems.length === 1, "Expected exactly one item in the list of updated work items");
                            // Notify that the change has been completed.
                            changeHandler(args);
                        },
                        (err) => {
                            // Notify that the change has been completed.
                            changeHandler(err, TaskBoardViewState.SERVER_ERROR);
                        }
                    );
                } else {
                    // Notify that the change has been completed.
                    changeHandler(null, TaskBoardViewState.CLIENT_ERROR);
                }
            },
            (error) => {
                // Since the work item could not be loaded update the model with the information about the error.
                this._model.setWorkItemError(id, error);

                // Notify that the change has been completed.
                changeHandler(error, TaskBoardViewState.SERVER_ERROR);
            }
        );
    }

    /**
     * Handle a request to edit a work item by displaying the appropriate work item edit form
     * @param id The work item ID
     */
    private _editWorkItem(id: number) {
        Diag.Debug.assert(typeof id === "number", "Expected a number to be passed to editWorkItem");

        // in both close and save we need to do the same thing because an item may be in error state so we need to refresh the UI in any case
        const closeHandler = (workItem: WITOM.WorkItem) => {
            if (!this.isDisposed) {
                this._workItemCloseHandler(id, workItem);
            }
        };

        WITDialogShim.showWorkItemById(id, this._model.tfsContext, {
            addQueryParam: true,
            close: closeHandler
        });
    }

    /** Public for unit testing */
    public _workItemCloseHandler(id: number, workItem: WITOM.WorkItem) {
        Diag.logTracePoint("taskboard_editWorkItemServerSave.complete");
        if (workItem) {
            if (this._model.isParentId(id)) {
                // update the pivot parent workitem title
                this._view.refreshPivotAfterEdit(id);
            } else if (workItem.isNew()) {
                // the new item has been discarded
                this._view.removeItems([id]);
            } else {
                // refresh the tile
                if (id < 0) {
                    this._view.rebindTile(id, workItem.id);
                    id = workItem.id;
                }
                this._updatePeopleFilter();
                this._view.refreshTileAfterEdit(id);
            }
        }
        Diag.logTracePoint("taskboard_editWorkItemDisplay.complete");
    }

    public moveWorkItemToIteration(workItemId: number, iterationPath: string, $tile?: JQuery) {
        this.getTaskBoardView().showSavingOverlay(workItemId);
        new TFS_Agile_Utils.MoveToIterationHelper()
            .moveToIteration([workItemId], iterationPath, CustomerIntelligenceConstants.CustomerIntelligencePropertyValue.VIEWTYPE_TASKBOARD)
            .then(
                (updatedWorkItemIds: number[]) => {
                    // We need to evaluate the parent-children links of the workitem being moved to identify which items needs to be removed from current view.
                    // Previously we were removing the workitem on which the moveToIteration was triggered. This works if that work item is a parent type, but causes issues if that work item is a children type.
                    // We are undoing the fix for the bug 1280676 since that fix causes another critical bug 1517330. Refer the bug for specific scenarios where the issue happens.

                    // Remove updated workitems from board
                    this.getTaskBoardView().removeItems(updatedWorkItemIds);

                    if ($tile && !Utils_Array.contains(updatedWorkItemIds, workItemId)) {
                        // Dragged item has not been updated, restore tile visibility
                        $tile.css("visibility", "visible");
                    }

                    this.getTaskBoardView().hideSavingOverlay(workItemId);
                },
                (errorMessage: string) => {
                    if ($tile) {
                        $tile.css("visibility", "visible");
                    }
                    this.getTaskBoardView().hideSavingOverlay(workItemId);
                    this.getTaskBoardView().showError(workItemId, {
                        name: errorMessage,
                        message: errorMessage
                    });
                }
            );
    }

    /**
     * Handle a request to discard the work item
     *
     * @param id The work item ID
     */
    private _discardNewWorkItem(id: number) {
        Diag.Debug.assertParamIsNumber(id, "id");
        this._model.getWorkItemManager().beginGetWorkItem(id, (workItem: WITOM.WorkItem) => {
            if (workItem && workItem.isNew()) {
                this._view.removeItems([id]);
                workItem.discardIfNew();
            }
        });
    }

    private _createNewWorkItem(workItemType: string, iterationPath: string, parentId?: number, isNewParentItem: boolean = false) {
        const createWorkItem = (workItemType: WITOM.WorkItemType) => {
            WorkItemUtils.beginCreateWorkItem(this._model.teamId, workItemType).then(
                (workItem: WITOM.WorkItem) => {
                    if (parentId) {
                        workItem.addLinks([WITOM.WorkItemLink.create(workItem, WorkItemUtils.PARENT_LINK_NAME, parentId, "")]);
                        // inherit field values from parent (using cached/payload data)
                        workItem.setFieldValue(
                            WITConstants.CoreFieldRefNames.AreaId,
                            this._model.getFieldValue(parentId, WITConstants.CoreFieldRefNames.AreaId)
                        );
                        workItem.setFieldValue(
                            this._model.getTeamFieldRefName(),
                            this._model.getFieldValue(parentId, this._model.getTeamFieldRefName())
                        );
                    }

                    // set the work item iteration to that of the current taskboard
                    WorkItemUtils.setWorkItemIterationUsingAgileContext(workItem);

                    // override the work item iteration
                    workItem.setFieldValue(WITConstants.CoreField.IterationPath, iterationPath);

                    if (!this.isDisposed) {
                        // apply the current filter value
                        this._model.applyFilterValues(workItem);

                        // update the view with the new work item tile
                        this._view.createNewTile(workItem.getUniqueId(), isNewParentItem);
                    }
                },
                (error: TfsError) => VSS.handleError(error)
            );
        };

        TFS_Agile_Utils.WorkItemUtils.beginGetWorkItemType(workItemType).then(
            (workItemType: WITOM.WorkItemType) => {
                if (!this.isDisposed) {
                    this._model.getWorkItemStore().beginGetLinkTypes(() => {
                        createWorkItem(workItemType);
                    });
                }
            },
            (error: TfsError) => VSS.handleError(error)
        );
    }

    /**
     * Attaches event handlers to the view events.
     */
    private _attachViewEvents() {
        this._view.attachNewParentWorkItemDiscarded(this._newParentItemDiscardedHandler);
        this._view.attachWorkItemDragging(this._workItemDraggingHandler);
        this._view.attachWorkItemChangeRequested(this._workItemChangeRequestedHandler);
        this._view.attachWorkItemReorderRequested(this._workItemReorderRequestedHandler);
        this._view.attachEditWorkItem(this._editWorkItemHandler);
        this._view.attachCreateNewWorkItem(this._createNewWorkItemHandler);
        this._view.attachDiscardWorkItem(this._discardWorkItemHandler);
        this._view.attachMoveWorkItemToIteration(this._moveWorkItemToIterationHandler);
        this._attachWorkItemChangeEvent();
    }

    /**
     * Detaches event handlers from the view events.
     */
    private _detachViewEvents() {
        this._view.detachNewParentWorkItemDiscarded(this._newParentItemDiscardedHandler);
        this._view.detachWorkItemDragging(this._workItemDraggingHandler);
        this._view.detachWorkItemChangeRequested(this._workItemChangeRequestedHandler);
        this._view.detachWorkItemReorderRequested(this._workItemReorderRequestedHandler);
        this._view.detachEditWorkItem(this._editWorkItemHandler);
        this._view.detachCreateNewWorkItem(this._createNewWorkItemHandler);
        this._view.detachDiscardWorkItem(this._discardWorkItemHandler);
        this._view.detachMoveWorkItemToIteration(this._moveWorkItemToIterationHandler);
        this._detachWorkItemChangeEvent();
        this._detachCommonConfigurationRegistration();
    }

    private _detachCommonConfigurationRegistration() {
        Events_Action.getService().unregisterActionWorker(
            ConfigurationsConstants.Actions.LAUNCH_COMMON_CONFIGURATION,
            this._launchCommonConfiguration
        );
    }

    private _ensureInitializedBacklogLevelHelper() {
        if (!this._backlogLevelHelper) {
            this._backlogLevelHelper = new TFS_Agile_WorkItemChanges.BacklogLevelHelper();
        }
    }

    private _attachWorkItemChangeEvent() {
        this._workItemChangeEventHandler = (sender: WorkItemManager, args: WITOM.IWorkItemChangedArgs) => {
            Diag.Debug.assertParamIsObject(args, "args");
            Diag.Debug.assertParamIsObject(args.workItem, "args.workItem");

            const { workItem } = args;
            if (workItem && workItem.id) {
                var workItemId = workItem.id;
                switch (args.change) {
                    case WorkItemChangeType.Saved:
                        if (this._workItemIdsToRemove[workItemId]) {
                            delete this._workItemIdsToRemove[workItemId];
                            this.getTaskBoardView().removeItems([workItemId], true);
                        }
                        break;
                    case WorkItemChangeType.ProjectChanged:
                        this._workItemIdsToRemove[workItemId] = workItemId;
                        break;
                    case WorkItemChangeType.TypeChanged:
                        var originalWorkItemType = args.workItem.getOriginalWorkItemType();
                        var workItemType = args.workItem.workItemType;
                        if (!this._areSameBacklogLevel(originalWorkItemType.name, workItemType.name)) {
                            this._workItemIdsToRemove[workItemId] = workItemId;
                        } else if (originalWorkItemType.project.id === args.workItem.workItemType.project.id) {
                            // if types changed are in the same backlog level, and the project names are the same.
                            delete this._workItemIdsToRemove[workItemId];
                        }
                        break;
                    case WorkItemChangeType.Discarded:
                    case WorkItemChangeType.Reset:
                    case WorkItemChangeType.Refresh:
                        delete this._workItemIdsToRemove[workItemId];
                        break;
                    default:
                        break;
                }
            }
        };

        this.getWorkItemManager().attachWorkItemChanged(this._workItemChangeEventHandler);
    }

    private _areSameBacklogLevel(workItemType: string, workItemTypeToCompare: string): boolean {
        this._ensureInitializedBacklogLevelHelper();
        var level = this._backlogLevelHelper.getLevel(workItemType);
        var levelToCompare = this._backlogLevelHelper.getLevel(workItemTypeToCompare);
        return level !== -1 && levelToCompare !== -1 && level === levelToCompare;
    }

    private _detachWorkItemChangeEvent() {
        this._workItemIdsToRemove = {};
        this.getWorkItemManager().detachWorkItemChanged(this._workItemChangeEventHandler);
    }

    private _handleDeleteStarted = (startedArguments: WITControls_RecycleBin.IDeleteEventArguments) => {
        const workItemIds = startedArguments.workItemIds;
        if (workItemIds && workItemIds.length > 0) {
            // Allow JQuery to complete the drop operation and remove the cloned tile
            Utils_Core.delay(this, 0, () => {
                this._view.removeItems(workItemIds, true);
            });
        }
    };

    private _handleDeleteFailed = (message: string) => {
        this._view.getMessageArea().setError(message, () => {
            window.location.reload();
        });
    };

    private _addOrUpdateBoardItemOnAutoRefresh = (autoRefreshEventPayload: TaskboardWorkItemChangedPayload): void => {
        const { id, iterationPath, revision, parentId, parentChangeType } = autoRefreshEventPayload;

        // check if this work item should be on the board based on the iteration path
        const isWorkItemIterationUnderTaskboard = TFS_Agile.ClassificationPathUtils.isClassificationPathEqualOrUnderRelative(
            /*projectNames*/ [],
            /*pathToCheck*/ iterationPath,
            /*basePath*/ "\\" + this._iterationPath,
            /*includeChildren*/ true
        );

        if (isWorkItemIterationUnderTaskboard) {
            if (this._model.shouldRefreshWorkItem(id, revision, parentChangeType, parentId)) {
                const previousWorkItemTypeName = this._model.getFieldValue(id, DatabaseCoreFieldRefName.WorkItemType);
                this._view.toggleUpdatesDueToAutoRefresh(id, true);
                this._model.refreshWorkItem(id, (workItem: WITOM.WorkItem) => {
                    const isVisible = this._isSignalRUpdateVisible(id);
                    // still need to run this in case the change is a work item type getting changed
                    this._addOrUpdateBoardItem(workItem, previousWorkItemTypeName, isVisible);
                    this._view.toggleUpdatesDueToAutoRefresh(id, false);
                });
            }
        } else {
            if (this._model.isWorkItemOnTheBoard(id)) {
                const isParentType: boolean = this._model.isParentId(id);
                if (isParentType) {
                    if (this._model.shouldRefreshWorkItem(id, revision, parentChangeType, parentId)) {
                        this._view.toggleUpdatesDueToAutoRefresh(id, true);
                        this._model.refreshWorkItem(id, (workItem: WITOM.WorkItem) => {
                            const isVisible = this._isSignalRUpdateVisible(id);
                            isVisible && this._view.refreshTile(workItem.id);
                            this._view.toggleUpdatesDueToAutoRefresh(id, false);
                        });
                    }
                } else {
                    this._view.toggleUpdatesDueToAutoRefresh(id, true);
                    // remove child item that doesn't match iteration path
                    this._removeBoardItem(autoRefreshEventPayload);
                    this._view.toggleUpdatesDueToAutoRefresh(id, false);
                }
            }
            // else - not on the board so ignore
        }
    };

    private _isSignalRUpdateVisible(id: number): boolean {
        this._model.refreshVisibleIds();
        return this._model.isItemVisible(id);
    }

    private _addOrUpdateBoardItem = (workItem: WITOM.WorkItem, previousWorkItemTypeName?: string, isVisible = true) => {
        // Check if work item type belongs to the Taskboard
        const backlogConfiguration = BacklogConfigurationService.getBacklogConfiguration();
        if (!backlogConfiguration.isWorkItemTypeInTaskBacklog(workItem.workItemType.name)) {
            // If there is no tile already then just return, otherwise we need to remove the tile and show the user the message for manual refresh below
            if (!this.isWorkItemOnTheBoard(workItem.id)) {
                return;
            }
        }

        const isChildWorkItemType = Utils_Array.contains(
            this._model.getChildWorkItemTypes(),
            workItem.workItemType.name,
            Utils_String.ignoreCaseComparer
        );

        if (previousWorkItemTypeName) {
            const wasChildWorkItemType = Utils_Array.contains(
                this._model.getChildWorkItemTypes(),
                previousWorkItemTypeName,
                Utils_String.ignoreCaseComparer
            );
            if (
                Utils_String.ignoreCaseComparer(previousWorkItemTypeName, workItem.workItemType.name) !== 0 &&
                !(isChildWorkItemType && wasChildWorkItemType)
            ) {
                /** Based on the existing behaviour if the work item type has changed (unless from one child type to another) we will just remove the item from the board
                 * this is an edge case and correctly updating the model+view to accommodate the new type in terms of parent row/children
                 * would complicate things and would also need to be reproduced in the non-live update scenario.
                 *
                 * Note: we do not receive live update events for work item types that are not valid on the taskboard, so a change to those will result
                 * in stale data on the board even with live updates running.
                 */
                PublishAutoRefreshTelemetry(Events.WorkItemRemovedDueToTypeChange, this._model.teamId, {});
                this._promptForManualRefresh(
                    Utils_String.format(
                        AgileControlsResources.RefreshNotification_WorkItemRemovedDueToTypeChange,
                        previousWorkItemTypeName,
                        workItem.id
                    )
                );
                this._view.removeItems([workItem.id], /*unparentChildren*/ true);
                return;
            }
        }

        const parentLink = WorkItemUtils.getWorkItemParentLink(workItem);
        if (isChildWorkItemType && parentLink && !this._model.isWorkItemOnTheBoard(parentLink.getTargetId())) {
            // display the missing parent and then the child
            this._model.refreshWorkItem(parentLink.getTargetId(), (parentWorkItem: WITOM.WorkItem) => {
                // at this point, the work item changes have been taken up by the model,
                // and we only display those changes if the work item is visible
                if (isVisible) {
                    const isChildWorkItemType = Utils_Array.contains(
                        this._model.getChildWorkItemTypes(),
                        parentWorkItem.workItemType.name,
                        Utils_String.ignoreCaseComparer
                    );
                    if (!isChildWorkItemType) {
                        this._view.displayWorkItem(parentWorkItem.id, this._model.isParentId(parentWorkItem.id));
                    }
                    this._view.displayWorkItem(workItem.id, this._model.isParentId(workItem.id));
                }
            });
        } else if (isVisible) {
            this._view.displayWorkItem(workItem.id, this._model.isParentId(workItem.id));
        }
    };

    private _removeBoardItem = (autoRefreshEventPayload: TaskboardWorkItemChangedPayload): void => {
        this._view.removeItems([autoRefreshEventPayload.id], /*unparentChildren*/ true);
    };

    private _autoRefreshBoardItems = (sender: any, autoRefreshEventPayload: TaskboardWorkItemChangedPayload): void => {
        switch (autoRefreshEventPayload.changeType) {
            case EventType.ItemUpdated:
            case EventType.ItemCreated:
            case EventType.ItemAdded:
            case EventType.ItemRestored: {
                this._addOrUpdateBoardItemOnAutoRefresh(autoRefreshEventPayload);
                this._taskboardAutoRefreshEventsHelper.fire(Events.ItemsAutoRefreshCompleted, this, /*itemsRefreshCount*/ 1);
                break;
            }
            case EventType.ItemDeleted:
            case EventType.ItemRemoved: {
                this._removeBoardItem(autoRefreshEventPayload);
                this._taskboardAutoRefreshEventsHelper.fire(Events.ItemsAutoRefreshCompleted, this, /*itemsRefreshCount*/ 1);
                break;
            }
            default: {
                Diag.logTracePoint(TracePoints.ErrorUnknownEventType);
                this._taskboardAutoRefreshEventsHelper.fire(Events.ItemsAutoRefreshCompleted, this, /*itemsRefreshCount*/ 0);
                break;
            }
        }
    };

    private _handleWorkItemTaskboardColumnChangedEvents = (sender: any, payload: WorkItemTaskboardColumnChangedEvent): void => {
        const { workItemId, columnId } = payload;

        if (this._model.areColumnsCustomized) {
            const currentColumnId = this._model.getColumnId(workItemId);
            if (currentColumnId !== columnId) {
                this._model.workItemColumnIdMap[workItemId] = columnId;
                this._view.refreshTile(workItemId);
            }
        }
    };

    private _handleTaskboardColumnOptionsChangedEvents = (): void => {
        this._tearDownAutoRefresh(
            /*promptForManualRefresh*/ true,
            Events.TaskboardColumnOptionsChanged,
            AgileControlsResources.RefreshNotification_SettingsChanged
        );
    };

    private _handleTaskboardCardSettingsChangedEvents = (): void => {
        this._tearDownAutoRefresh(
            /*promptForManualRefresh*/ true,
            Events.TaskboardCardSettingsChanged,
            AgileControlsResources.RefreshNotification_SettingsChanged
        );
    };

    private _handleTeamSettingsChangedEvents = (): void => {
        this._tearDownAutoRefresh(
            /*promptForManualRefresh*/ true,
            Events.TeamSettingsChanged,
            AgileControlsResources.RefreshNotification_SettingsChanged
        );
    };

    private _handleSignalRDisconnectedEvents = (): void => {
        this._tearDownAutoRefresh(
            /*promptForManualRefresh*/ true,
            Events.SignalRDisconnected,
            AgileControlsResources.RefreshNotification_ConnectionTimedout
        );
    };

    private _handleVisibilityChanged = (): void => {
        if (document.hidden) {
            this._signalRDisconnectTimer = setTimeout(() => {
                // Clear the timeout when the session stays inactive for time interval more than the threshold.
                clearTimeout(this._signalRDisconnectTimer);
                this._signalRDisconnectTimer = null;
                this._tearDownAutoRefresh(
                    /*promptForManualRefresh*/ true,
                    Events.SignalRDisconnectedDueToTabInactiveness,
                    AgileControlsResources.RefreshNotification_IdleDisconnect
                );
            }, this._browserTabInactiveTimeInMillseconds);
        } else if (this._signalRDisconnectTimer) {
            // Clear the timer when the session becomes active before the threshold time.
            clearTimeout(this._signalRDisconnectTimer);
            this._signalRDisconnectTimer = null;
        } else {
            // page has become visible after signalR disconnected, refresh the page
            this._view
                .getMessageArea()
                .setMessage(
                    AgileControlsResources.RefreshNotification_IdleDisconnect + AgileControlsResources.RefreshingNotification,
                    Notifications.MessageAreaType.Warning
                );
            document.location.reload();
        }
    };

    /**
     * Subcribes to auto-refresh events.
     */
    private _subscribeForBoardItemChangeEvents(): void {
        this._taskboardAutoRefreshEventsHelper.attachEvent(Events.ItemsNeedAutoRefresh, this._autoRefreshBoardItems);
        this._taskboardAutoRefreshEventsHelper.attachEvent(Events.WorkItemTaskboardColumnChanged, this._handleWorkItemTaskboardColumnChangedEvents);
    }

    private _subscribeToSettingsChangeEvents(): void {
        this._taskboardAutoRefreshEventsHelper.attachEvent(Events.TaskboardColumnOptionsChanged, this._handleTaskboardColumnOptionsChangedEvents);
        this._taskboardAutoRefreshEventsHelper.attachEvent(Events.TaskboardCardSettingsChanged, this._handleTaskboardCardSettingsChangedEvents);
        this._taskboardAutoRefreshEventsHelper.attachEvent(Events.TeamSettingsChanged, this._handleTeamSettingsChangedEvents);
    }

    private _subscribeToSignalRDisconnectedEvents(): void {
        this._taskboardAutoRefreshEventsHelper.attachEvent(Events.SignalRDisconnected, this._handleSignalRDisconnectedEvents);
    }

    private _unsubscribeFromBoardItemChangeEvents(): void {
        this._taskboardAutoRefreshEventsHelper.detachEvent(Events.ItemsNeedAutoRefresh, this._autoRefreshBoardItems);
        this._taskboardAutoRefreshEventsHelper.detachEvent(Events.WorkItemTaskboardColumnChanged, this._handleWorkItemTaskboardColumnChangedEvents);
    }

    private _unsubscribeToSettingsChangeEvents(): void {
        this._taskboardAutoRefreshEventsHelper.detachEvent(Events.TaskboardColumnOptionsChanged, this._handleTaskboardColumnOptionsChangedEvents);
        this._taskboardAutoRefreshEventsHelper.detachEvent(Events.TaskboardCardSettingsChanged, this._handleTaskboardCardSettingsChangedEvents);
        this._taskboardAutoRefreshEventsHelper.detachEvent(Events.TeamSettingsChanged, this._handleTeamSettingsChangedEvents);
    }

    private _unsubscribeToSignalRDisconnectedEvents(): void {
        this._taskboardAutoRefreshEventsHelper.detachEvent(Events.SignalRDisconnected, this._handleSignalRDisconnectedEvents);
    }

    private _attachVisibilityChangesHandler(): void {
        $(document).on("visibilitychange", this._handleVisibilityChanged);
    }

    private _detachVisibilityChangedHandler(): void {
        $(document).off("visibilitychange", this._handleVisibilityChanged);
    }

    private _tearDownAutoRefresh(promptForManualRefresh: boolean, eventName?: string, message?: string): void {
        this._unsubscribeFromBoardItemChangeEvents();
        this._unsubscribeToSettingsChangeEvents();
        this._unsubscribeToSignalRDisconnectedEvents();

        if (this._boardHub) {
            this._boardHub.stop();
            this._boardHub.dispose();
            this._boardHub = null;
        }
        if (eventName) {
            PublishAutoRefreshTelemetry(eventName, this._model.teamId, {});
        }
        if (promptForManualRefresh) {
            this._promptForManualRefresh(message);
        }
    }

    private _promptForManualRefresh(message?: string) {
        const refreshLink = $("<a/>")
            .text(AgileControlsResources.RefreshNotification_Click)
            .attr("role", "button")
            .click(() => {
                window.location.reload();
            });
        let messageContainer = $("<div/>").text(message).append(refreshLink);
        this._view.getMessageArea().setMessage({
            type: Notifications.MessageAreaType.Warning,
            header: messageContainer
        });
    }

    /**
     * Creates the SignalR hub and associated events and handlers
     * Returns Q.Promise of the HubConnection object (used only in tests)
     */
    private _setupAutoRefresh(): Q.Promise<TaskboardAutoRefreshHub_NO_REQUIRE.TaskboardAutoRefreshHub> {
        const deferred = Q.defer<TaskboardAutoRefreshHub_NO_REQUIRE.TaskboardAutoRefreshHub>();
        this._unsubscribeFromBoardItemChangeEvents();
        this._subscribeForBoardItemChangeEvents();

        // Connect to SignalR server to receive notifications for work item changes and common settings changes.
        if (!this._boardHub) {
            // Subscribe to settings changes and signalR connection revived events.
            this._subscribeToSettingsChangeEvents();
            this._subscribeToSignalRDisconnectedEvents();

            // Subscribe to document visibility changed events.
            this._attachVisibilityChangesHandler();

            let scriptsToLoad = ["Agile/Scripts/SprintsHub/Taskboard/AutoRefresh/TaskboardAutoRefreshHub"];
            if (this._signalRHubUrl) {
                scriptsToLoad.push(this._signalRHubUrl);
            }

            VSS.using(
                scriptsToLoad,
                (TaskboardAutoRefreshHub: typeof TaskboardAutoRefreshHub_NO_REQUIRE) => {
                    if (!this._disposed) {
                        this._boardHub = new TaskboardAutoRefreshHub.TaskboardAutoRefreshHub(
                            this._model.teamId,
                            this._taskboardAutoRefreshEventsHelper
                        );
                        this._boardHub.start().then(
                            (hub: TaskboardAutoRefreshHub_NO_REQUIRE.TaskboardAutoRefreshHub) => {
                                deferred.resolve(this._boardHub);
                            },
                            (error: Error) => {
                                deferred.reject(error);
                            }
                        );
                    } else {
                        deferred.reject("The taskboard was disposed");
                    }
                },
                (error: Error) => {
                    deferred.reject({
                        name: "Taskboard.AutoRefresh.ScriptLoad.Failure",
                        message: "Taskboard autoRefresh Signal script loading failed"
                    });
                }
            );
        } else {
            deferred.resolve(this._boardHub);
        }
        return deferred.promise;
    }
}

VSS.initClassPrototype(TaskBoard, {
    _container: null,
    _model: null,
    _view: null,
    _workItemDraggingHandler: null,
    _workItemChangeRequestedHandler: null,
    _workItemReorderRequestedHandler: null,
    _editWorkItemHandler: null,
    _pivotFilter: null
});
